import { render, staticRenderFns } from "./TeamOrMemberItem.vue?vue&type=template&id=aaa91ee2&scoped=true&"
import script from "./TeamOrMemberItem.vue?vue&type=script&lang=ts&"
export * from "./TeamOrMemberItem.vue?vue&type=script&lang=ts&"
import style0 from "./TeamOrMemberItem.vue?vue&type=style&index=0&id=aaa91ee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa91ee2",
  null
  
)

export default component.exports